import trimStart from 'lodash/trimStart';
import axios from 'axios';

import config from 'config';
import { bind } from 'utils';

/**
 * API methods
 */
export default class APIRequest {
  constructor () {
    bind(this, [
      'delete',
      'get',
      'post',
      'put',
      'request'
    ]);
  }

  /**
   * Get root
   */
  get root () {
    return config.api.url || '';
  }

  /**
   * Delete
   */
  delete (endpoint) {
    return this.request('delete', endpoint);
  }

  /**
   * Get
   */
  get (endpoint) {
    return this.request('get', endpoint);
  }

  /**
   * Post
   */
  post (endpoint, data) {
    return this.request('post', endpoint, data);
  }

  /**
   * Put
   */
  put (endpoint, data) {
    return this.request('put', endpoint, data);
  }

  /**
   * Perform request
   */
  request (method, endpoint, data = {}, headers = {}) {
    const args = {
      url: this.root + trimStart(endpoint),
      method: method,
      headers: headers
    };

    if (['get'].indexOf(method) >= 0) {
      args.params = (data);
    }

    if (['post', 'put'].indexOf(method) >= 0) {
      args.data = (data);
    }

    if (config.api.token) {
      args.headers['X-API-KEY'] = config.api.token;
    }

    return axios(args).then(response => response.data).catch(exception => Promise.reject(exception));
  }

  /**
   * Perform request to avoindata
   */
  getCompanyData (nameOrId) {
    const businessIdUrl = `${config.api.companyUrl}opendata-ytj-api/v3/companies?businessId=${nameOrId}`;
    const nameUrl = `${config.api.companyUrl}opendata-ytj-api/v3/companies?name=${encodeURIComponent(nameOrId)}`;

    const businessIdRequest = axios.get(businessIdUrl).then(res => res.data).catch(() => null);
    const nameRequest = axios.get(nameUrl).then(res => res.data).catch(() => null);

    return Promise.all([businessIdRequest, nameRequest])
      .then(([businessIdData, nameData]) => {
        if (businessIdData && businessIdData.totalResults > 0) {
          return businessIdData;
        } else if (nameData && nameData.totalResults > 0) {
          return nameData;
        } else {
          return Promise.reject(new Error('No company data found'));
        }
      })
      .catch(exception => Promise.reject(exception));
  }

  getBlogPosts () {
    const args = {
      url: 'https://www.fundu.fi/wp-json/wp/v2/posts?categories=49',
      method: 'get'
    };

    return axios(args)
      .then((response) => response.data)
      .catch((exception) => Promise.reject(exception));
  }

  sendLead(leadData) {
    return this.request('post', 'leads', leadData);
  }
}
